import { IGetState, TBoardId } from '../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../types/actions';
import { fetchHandler } from '../../../../util/fetchHandler';
import { Util } from '../../../../util/util';
import { REST_WEBHOOKS } from '../../../constants';
import { getRestHeadersGet } from '../../../helpers/getRestHeadersHelper';

export const getRest = (
    boardId: TBoardId,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return fetchHandler<any>(
            Util.getApiUrl(REST_WEBHOOKS + boardId),
            getRestHeadersGet(),
        ).then(response => {
            return response;
        });
    };
    return action;
};
